import type { ReactNode } from 'react';
import { NotificationsProvider, getNotificationsInitializer } from './notifications.store';

const initializer = getNotificationsInitializer();

function NotificationsRoot({ children }: { children: ReactNode | ReactNode[] }) {
  return <NotificationsProvider initializer={initializer}>{children}</NotificationsProvider>;
}

export { NotificationsRoot as Root };
